<template>
    <div class="plane" :class="{'plane-sales': salesMode}">
      <div class="cockpit">
        <h1>{{ $t('Elija Asiento') }}</h1>
      </div>

      <div class="exit exit--front fuselage"/>
      <div class="bathroom fuselage">
        <span class="bthr1"><i class="fas fa-restroom"></i></span>
      </div>
      <ol class="cabin fuselage">
        <li :class="ifExitRow(index)? 'row-- emergenseat':'row--'" v-for="index in seatMapRows" :key="'row-'+index">
          <span v-if="showExitLabel(index)">&lt; {{ $t('Salidas de emergencia') }} &gt;</span>
          <ol class="seats" type="A">
            <li class="seat" v-for="letter in letters" :key="index + letter"
                :class="{'seat-has-tooltip': salesMode && tooltipText(index, letter)}">
              <template v-if="seatExists(index, letter)">
                <input type="checkbox" :disabled="isNotAvailable(index, letter)" :checked="isCurrentPax(index, letter)" />
                <label
                  @click="assignSeat(index, letter)"
                  @mouseenter="onSeatHover(index, letter)"
                  @mouseleave="onSeatLeave"
                  :class="seatPriceClass(index, letter)"
                  :data-tooltip="tooltipText(index, letter)"
                >
                  {{index}}{{letter}}
                </label>
              </template>
            </li>
          </ol>
        </li>
      </ol>
      <div class="exit exit--back fuselage"/>

    </div>
</template>

<script>
  import moment from 'moment';
  export default {
    name: "Seatmap-plane",
    props: {
      seatMap: { type: Object, default: function () { return {}; } },
      currentPax: { default: null },
      prices: { type: Object, default: function () { return {}; } },
      salesMode: { type: Boolean, default: false },
    },
    data: function () {
      return {
        letters: ['A', 'B', 'C', 'D', 'E', 'F'],
      };
    },
    methods: {
      seatKey: function(row, letter) {
        return String(row) + letter;
      },
      seatExists: function(row, letter) {
        if (!this.seatMap) {
          return false;
        }
        return Object.prototype.hasOwnProperty.call(this.seatMap, this.seatKey(row, letter));
      },
      isCurrentPax: function(row, letter) {
        let key = this.seatKey(row, letter);
        if (this.currentPax != null) {
          return key === this.currentPax.paxLeg.UnitDesignator;
        }
        return false;
      },
      isNotAvailable: function(row, letter) {
        let key = this.seatKey(row, letter);
        if (!this.seatExists(row, letter)) {
          return true;
        }
        let seat = this.seatMap[key];
        // sales: allow exit rows (with age check); block other NotWebCheckin seats
        // check-in web: block NotWebCheckin and exit rows
        if (this.salesMode) {
          if (seat.NotWebCheckin && !seat.ExitRow) {
            return true;
          }
        } else if (seat.NotWebCheckin || seat.ExitRow) {
          return true;
        }
        return seat.Status !== 'AVAILABLE'
                || (this.hasInfant && !seat.AllowInfant)
                || (this.cantPaxBeInExitSeat && seat.ExitRow);
      },
      seatInfo: function (row, letter) {
        let key = this.seatKey(row, letter);
        return (this.prices && this.prices[key]) || null;
      },
      seatAmount: function (row, letter) {
        let info = this.seatInfo(row, letter);
        if (!info) return null;
        return info.Amount;
      },
      tooltipText: function (row, letter) {
        if (!this.salesMode) return '';
        let info = this.seatInfo(row, letter);
        if (!info) return '';
        let zone = info.ZoneName || info.ZoneCode || '';
        let amount = Number(info.Amount);
        let price = amount === 0
          ? this.$t('Gratis')
          : (info.CurrencyId || 'ARS') + ' ' + amount.toLocaleString('es-AR', { maximumFractionDigits: 0 });
        return zone ? (zone + ' · ' + price) : price;
      },
      seatPriceClass: function (row, letter) {
        let amount = this.seatAmount(row, letter);
        if (amount == null) return '';
        if (Number(amount) === 0) return 'seat-price-free';
        if (Number(amount) > 0) return 'seat-price-paid';
        return '';
      },
      assignSeat: function(row, letter) {
        let key = this.seatKey(row, letter);
        if (this.isNotAvailable(row, letter)) {
          return;
        }
        this.$emit('assignSeat', this.currentPax, key);
      },
      onSeatHover: function (row, letter) {
        let text = this.tooltipText(row, letter);
        if (!text && this.salesMode) {
          text = this.seatKey(row, letter) + ' · Sin precio de zona';
        } else if (!text) {
          text = this.seatKey(row, letter);
        }
        this.$emit('seatHover', text);
      },
      onSeatLeave: function () {
        this.$emit('seatHover', '');
      },
      ifExitRow: function(row) {
        return this.exitRows.indexOf(row) !== -1;
      },
      showExitLabel: function(row) {
        if (!this.ifExitRow(row)) {
          return false;
        }
        let i = this.seatMapRows.indexOf(row);
        if (i <= 0) {
          return true;
        }
        return !this.ifExitRow(this.seatMapRows[i - 1]);
      },
    },
    computed: {
      cantPaxBeInExitSeat: function() {
        if (!this.currentPax || !this.currentPax.pax) return true;
        let age = moment().diff(moment(this.currentPax.pax.DOB, "YYYY-DD-MM"), 'years');
        return age < 14 || age > 70 || this.hasInfant;
      },
      hasInfant: function() {
        return this.currentPax && this.currentPax.pax && this.currentPax.pax.Infant;
      },
      seatMapRows: function() {
        if (!this.seatMap || !Object.keys(this.seatMap).length) {
          return [];
        }
        let rows = Object.values(this.seatMap).map(s => s.Row);
        return rows.filter((row, i) => rows.indexOf(row) === i).sort((a, b) => a - b);
      },
      exitRows: function() {
        if (!this.seatMap) {
          return [];
        }
        return Object.values(this.seatMap).filter(s => s.ExitRow).map(s => s.Row)
          .filter((row, i, arr) => arr.indexOf(row) === i);
      }
    }
  }
</script>
